import { Reducer } from "redux";

import { NotificationDeactivateResponse } from "../models/api/Admin";
import { NotificationDeactivateDispatchTypes } from "../models/dispatchTypes/User";
import { NotificationDeactivateActionDispatchTypes } from "../constants/User";

const initialState: NotificationDeactivateResponse = {
  loading: false,
  response: false,
  error: null,
};

const DeactivateNotificationsReducer: Reducer<
  NotificationDeactivateResponse,
  NotificationDeactivateDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case NotificationDeactivateActionDispatchTypes.NOTIFICATION_DEACTIVATE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case NotificationDeactivateActionDispatchTypes.NOTIFICATION_DEACTIVATE_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case NotificationDeactivateActionDispatchTypes.NOTIFICATION_DEACTIVATE_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case NotificationDeactivateActionDispatchTypes.NOTIFICATION_DEACTIVATE_RESET: {
      return initialState;
    }
  }
  return state;
};

export default DeactivateNotificationsReducer;
